import { Component, OnInit } from '@angular/core';
import * as Twilio from 'twilio-video';
import { CommsService } from '../../services/comms.service';
import { Router } from '@angular/router';

//declare const Twilio: any;
declare global {
  interface Window { stream: any; }
}

@Component({
  selector: 'mb-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {
  video: any;
  activeRoom: any;
  previewTracks: any;
  identity: any;
  roomName: any;
  room: any;

  isMuted: boolean = false;
  isVideoPaused: boolean = false;

  token: string;
  isOtherUserConnected: boolean = false;

  constructor(private commsService: CommsService, private router: Router) {

  }

  ngOnInit(): void {
    //refer lib
    this.video = Twilio;

    //ME - create the viewing users video tracks before the other guy connects
    var localTracksPromise = this.previewTracks
      ? Promise.resolve(this.previewTracks)
      : this.video.createLocalTracks();

    let self = this;
    localTracksPromise.then(
      function (tracks: any) {
        self.previewTracks = self.previewTracks = tracks;
        let previewContainer = document.getElementById('me-video') as HTMLDivElement;
        if (!previewContainer.querySelector('video')) {
          self.attachTracks(tracks, previewContainer);
        }

        //Get video access token using custom Comms Service
        self.commsService.video().subscribe(
          r => {
            self.token = r;             //Cache access token locally            
            self.connectVideoSession(); //Connect to video room to communicate
          }
        );
      },
      function (error: any) {
        console.error('Unable to access local media', error);
      }
    );
  }

  connectVideoSession() {
    this.video.connect(this.token,
      {
        name: this.commsService.activeSessionInfo.id,
        preferredAudioCodecs: ['isac', 'opus'],
        preferredVideoCodecs: ['H264']
      }).then((room: any) => {
        console.log('Connected to Room "%s"', room.name);
        this.room = room; 
        let self = this;

        // new code

        // Removed unused preview track for toggle video on pause for hide preview track
        // Fix for IOS devices, preventing black screen appearing on iPhone
        this.room.localParticipant.videoTracks.forEach(
          publication => {
            const div = document.getElementById("me-video");
            // Attach current track
            div.appendChild(publication.track.attach());

            // Recheck tracks on device
            if (div.querySelectorAll('video') && div.querySelectorAll('video').length === 2) {
              // Pause and remove preview video
              div.querySelectorAll('video').item(0).pause();
              div.querySelectorAll('video').item(0).remove();
            }
          }
        );

        room.on('trackSubscribed', track => {
          console.log('Participant "%s" connected', track.identity);
          self.isOtherUserConnected = true;
          const div = document.getElementById("you-video");
          div.appendChild(track.attach());
        });
        room.on('trackUnsubscribed', track => {
          track.detach().forEach(element => element.remove());
          track.stop && track.stop();
        })
        room.on('participantDisconnected', (participant: any) => {
          console.log('Participant "%s" disconnected', participant);
          self.isOtherUserConnected = false;

          let videoContainer = document.getElementById('you-video-wrapper') as HTMLDivElement;
          while (videoContainer.firstChild) {
            videoContainer.removeChild(videoContainer.firstChild);
          }
          videoContainer.innerHTML = "";
          videoContainer.innerHTML = "<div id='you-video'></div>";
        });
      });
  }

  //Get the Tracks of the given Participant.
  getTracks(participant: any) {
    return Array.from(participant.tracks.values()).filter((publication: any) => {
      return publication.track;
    }).map((publication: any) => {
      return publication.track;
    });
  }

  //Attach the tracks to the DOM
  attachTracks(tracks: any, container: any) {
    tracks.forEach((track: any) => {
      container.appendChild(track.attach());
    });
  }

  // Detach the Tracks from the DOM.
  detachTracks(tracks: any) {
    let self = this;
    tracks.forEach((track: any) => {
      track.mediaStreamTrack.stop();
      track.detach().forEach(function (detachedElement: any) {
        detachedElement.remove();
        self.previewTracks = null;
      });
    });
  }

  // Detach the Participant's Tracks from the DOM.
  detachParticipantTracks(participant: any) {
    var tracks = Array.from(participant.tracks.values());
    this.detachTracks(tracks);
  }

  toggleVideo() {
    if (this.isVideoPaused) {
      this.isVideoPaused = false;
      this.room.localParticipant.videoTracks.forEach(
        publication => publication.track.enable()
      );
    }
    else {
      this.isVideoPaused = true;
      this.room.localParticipant.videoTracks.forEach(
        publication => publication.track.disable()
      );
    }
  }

  toggleMute() {
    if (this.isMuted) {
      this.isMuted = false;
      this.room.localParticipant.audioTracks.forEach(
        publication => publication.track.enable()
      );
    }
    else {
      this.isMuted = true;
      this.room.localParticipant.audioTracks.forEach(
        publication => publication.track.disable()
      );
    }
  }

  endSession() {
    localStorage.removeItem('sessionToken');
    try {
      this.previewTracks.forEach((publication) => {
        if (publication.mediaStreamTrack) {
          publication.mediaStreamTrack.stop();
        }
      })
      this.room.localParticipant.videoTracks.forEach((publication) => {
        if (publication.stop) {
          publication.stop();
          publication.detach().forEach((element: any) => element && element.remove());
        }
        
        if (publication.track.stop) {
          publication.track.detach().forEach((element: any) => element.remove());
          publication.track.stop();
        }
        publication.unpublish();
      });

      this.room.localParticipant.audioTracks.forEach((publication) => {
        if (publication.stop) {
          publication.stop();
          publication.detach().forEach((element: any) => element && element.remove());
        }
        if (publication.track.stop) {
          publication.track.detach().forEach((element: any) => element && element.remove());
          publication.track.stop();
        }
        publication.unpublish();
      });

      this.previewTracks = null;
      this.room.disconnect();
      this.room = null;
    } catch (e) {
      console.log('Error:', e);
    }
    this.router.navigateByUrl('/');
  }

}
